import { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

export default function UserInputForm(props) {
  const [value, setValue] = useState("");

  return (
    <div className="testing">
      <Box
        component="form"
        sx={{
          "& > :not(style)": { m: 0, width: "25ch" },
          backgroundColor: "#363636",
          height: "3.25em",
        }}
        noValidate
        autoComplete="off"
      >
        <TextField
          defaultValue={props.prevVal && !value ? props.prevVal : value}
          onChange={props.callbackFunc}
          sx={{
            display: "flex",
            label: { fontSize: "0.8rem", color: "white" },
            input: { fontSize: "0.8rem", color: "white", paddingLeft: "10px" },
          }}
          InputProps={{ disableUnderline: true }}
          id="standard-basic"
          label={props.inputName}
          variant="standard"
        />
      </Box>
    </div>
  );
}
